<action class="pe-auto button-inline _wishlist-toggle"
        [status]="status"
        [notification]="'Wishlist' | translate"
        (click)="handleClick()">
    <span class="flex flex-middle _icon">
        <i [ngClass]="inWishlist ? 'col-23 icon-wishlist-fill' : 'icon-wishlist-thin'"
           [attr.id]="'wishlist-toggle-icon-' + productId"></i>
    </span>
</action>